
export default {
  props: {
    tender: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      competition: []
    };
  },

  fetchOnServer: false,

  async fetch () {
    this.competition = await this.$axios.$get(
      `organization/competition/?id=${this.tender.id}`
    );
  }
};
